import { _isSSR } from './setSSR';
/**
 * Helper to get the document object. Note that in popup window cases, document
 * might be the wrong document, which is why we look at ownerDocument for the
 * truth. Also note that the SSR flag is used to test ssr scenarios even if
 * document is defined (from JSDOM for example.)
 *
 * @public
 */
export function getDocument(rootElement) {
    if (_isSSR || typeof document === 'undefined') {
        return undefined;
    }
    else {
        return rootElement && rootElement.ownerDocument ? rootElement.ownerDocument : document;
    }
}
//# sourceMappingURL=getDocument.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uifabric/utilities/lib/dom/getDocument.js
// module id = 68
// module chunks = 0